import { render, staticRenderFns } from "./Home_slider.vue?vue&type=template&id=475241ae&scoped=true&"
import script from "./Home_slider.vue?vue&type=script&lang=js&"
export * from "./Home_slider.vue?vue&type=script&lang=js&"
import style0 from "./Home_slider.vue?vue&type=style&index=0&id=475241ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475241ae",
  null
  
)

export default component.exports